import React, { useMemo } from 'react'

import Box from 'components_new/atoms/Box'

import MainKpiFocusContainer from './MainKpiFocusContainer'
import ListContainer from './ListContainer'

import NoValue from '../../Errors/NoValue'

import { TCoreWidgetFullyLoaded, WidgetType } from 'types/GlobalWidget'

import { useCurrencyConverter } from 'redux/hooks/CurrencyConverter'

import { translateWidgetType } from 'utils/enumTranslator'
import { getKpiOptionsSettings, TParsedKpiValues } from './utils'

interface KeyFigureProps {
  interactive: boolean
  setDetailsDialog: (initialId: string | null) => void
  onKpiClick?: (event: React.MouseEvent, kpiOptionId: string) => void
  scaleFactor: number
  widget: TCoreWidgetFullyLoaded
}

const KeyFigure = (props: KeyFigureProps) => {
  const { interactive, scaleFactor, setDetailsDialog, onKpiClick, widget } =
    props

  const currency = useCurrencyConverter()

  const data = useMemo(() => {
    return getKpiOptionsSettings(widget, currency)
  }, [widget, currency])

  if (widget.data && widget.data.values && widget.data.values.length > 0) {
    return (
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          color: 'text.primary'
        }}
      >
        <MainKpiFocusContainer
          data={data}
          interactive={interactive}
          widget={widget}
          onClick={(option: TParsedKpiValues) => setDetailsDialog(option.id)}
          onKpiClick={
            onKpiClick
              ? (e, option) => onKpiClick(e, option.id)
              : undefined
          }
          scaleFactor={scaleFactor}
        />
        <ListContainer
          data={data}
          interactive={interactive}
          widget={widget}
          scaleFactor={scaleFactor}
          onClick={(option: TParsedKpiValues) => setDetailsDialog(option.id)}
          onKpiClick={
            onKpiClick
              ? (e, option) => onKpiClick(e, option.id)
              : undefined
          }
        />
      </Box>
    )
  }

  return (
    <NoValue
      embedded={false}
      iconName={translateWidgetType[WidgetType.KEY_FIGURE].iconName}
      scaleFactor={scaleFactor}
    />
  )
}

export default KeyFigure
